import { IDENTITY_PARAMS, type LopTabLocation } from './types';

/**
 * "Same object" identity for a location (decision D4): pathname + the
 * identity-param allowlist (currently just `id`), sorted so query-string
 * order never produces two keys for the same identity.
 *
 * `/fund-form?id=5` and `/fund-form?id=9` are two different tabs.
 * `/settings/bank-accounts?search=x` is the SAME tab as
 * `/settings/bank-accounts` — `search` is a filter, not an identity param.
 */
export function tabKey(location: Pick<LopTabLocation, 'pathname' | 'search'>): string {
  const params = new URLSearchParams(location.search);
  const parts: string[] = [];
  for (const name of [...IDENTITY_PARAMS].sort()) {
    const value = params.get(name);
    if (value !== null) parts.push(`${name}=${value}`);
  }
  return parts.length > 0 ? `${location.pathname}?${parts.join('&')}` : location.pathname;
}
